import axios from "axios"
import Swal from "sweetalert2"
import { itemsPerPage } from "./global-actions-data"
import { getFormattedHeaders } from "./global-actions"

const apiUrl = process.env.REACT_APP_API_URL

// Error handler utility
const handleApiError = (
  error,
  defaultMessage = "Hubo un error, vuelve a intentarlo, Si el error persiste contacte al administrador."
) => {
  if (error.response) {
    if (error.response.status === 400) {
      Swal.fire({
        title: "¡Error!",
        confirmButtonColor: "#76b4ff",
        text: error.response.data.message || defaultMessage,
      })
    } else {
      Swal.fire({
        title: "¡Error!",
        confirmButtonColor: "#76b4ff",
        text: defaultMessage,
      })
    }
  } else if (error.request) {
    console.log(error.request)
    Swal.fire({
      title: "¡Error!",
      confirmButtonColor: "#76b4ff",
      text: defaultMessage,
    })
  } else {
    console.log("Error", error.message)
    Swal.fire({
      title: "¡Error!",
      confirmButtonColor: "#76b4ff",
      text: defaultMessage,
    })
  }
}

export const loginUser = async (email, pass, setLoading) => {
  try {
    setLoading?.(true)
    const result = await axios.post(`${apiUrl}/auth/login`, {
      email,
      password: pass,
    })

    if (result.data.code === "01") {
      Swal.fire({
        title: "¡Error!",
        confirmButtonColor: "#76b4ff",
        text: "No existe un usuario con los datos ingresados, verifique e intente nuevamente.",
      })
      throw new Error("Invalid credentials")
    }

    // Get user data with token
    const token = result.data.token
    const userData = await getUserData(token)
    return userData
  } catch (error) {
    handleApiError(error)
    throw error
  } finally {
    setLoading?.(false)
  }
}

export const getUserData = async (token) => {
  try {
    const userResult = await axios.get(`${apiUrl}/auth/whoiam`, {
      headers: {
        token,
      },
    })

    if (userResult.data.code === "01") {
      Swal.fire({
        title: "¡Error!",
        confirmButtonColor: "#76b4ff",
        text: "Token inválido, verifique e intente nuevamente.",
      })
      throw new Error("Invalid token")
    }

    userResult.data.data.token = token
    return userResult.data.data
  } catch (error) {
    handleApiError(error)
    throw error
  }
}

export const createUser = async (data, setLoading, token) => {
  try {
    setLoading?.(true)
    const result = await axios.post(`${apiUrl}/user`, data, {
      headers: {
        token,
      },
    })

    return result.data
  } catch (error) {
    handleApiError(error)
    throw error
  } finally {
    setLoading?.(false)
  }
}

export const getUsers = async (skip, setLoading, token) => {
  try {
    setLoading?.(true)
    const result = await axios.get(`${apiUrl}/user`, {
      headers: {
        token,
      },
      params: {
        skip,
        limit: itemsPerPage,
      },
    })

    const headersNeeded = ["totalitems", "totalpages", "currentpage"]
    const headers = getFormattedHeaders(result.headers, headersNeeded)
    const response = { data: result.data, headers }

    return response
  } catch (error) {
    handleApiError(error)
    throw error
  } finally {
    setLoading?.(false)
  }
}

export const getUser = async (id, setLoading, token) => {
  try {
    setLoading?.(true)
    const result = await axios.get(`${apiUrl}/user`, {
      headers: {
        token,
      },
      params: {
        skip: 0,
        limit: 0,
        query: {
          _id: id,
        },
      },
    })

    return result.data
  } catch (error) {
    handleApiError(error)
    throw error
  } finally {
    setLoading?.(false)
  }
}

export const updateUser = async (data, setLoading, token) => {
  try {
    setLoading?.(true)
    const result = await axios.put(`${apiUrl}/user/${data._id}`, data, {
      headers: {
        token,
      },
    })

    return result
  } catch (error) {
    handleApiError(error)
    throw error
  } finally {
    setLoading?.(false)
  }
}

// Legacy Redux exports for compatibility
export const lgUser = (payload) => ({
  type: "LOGIN_USER",
  payload,
})

export const logoutUser = () => ({
  type: "LOGOUT_USER",
})
